<template>
    <v-container fill-height fluid justify-center>
    <v-row>
      <v-col cols="8" offset="2">
        <v-card>
          <v-card-title>Register</v-card-title>
          <v-card-text>
            <div v-if="error" class="alert alert-danger">{{error}}</div>
            <form action="#" @submit.prevent="submit">
              <div class="form-group row">
                  <v-text-field
                    label="name"
                    id="name"
                    type="name"
                    name="name"
                    value
                    required
                    autofocus
                    v-model="form.name"
                  />
              </div>
              <div class="form-group row">
                  <v-text-field
                    label="idcliente"
                    id="idcliente"
                    name="idcliente"
                    value
                    required
                    autofocus
                    v-model="form.idcliente"
                  />
              </div>
              

              <div class="form-group row">

                  <v-text-field
                    label="email"
                    id="email"
                    type="email"
                    class="form-control"
                    name="email"
                    value
                    required
                    autofocus
                    v-model="form.email"
                  />

              </div>

              <div class="form-group row">

                  <v-text-field
                    id="password"
                    label ="password"
                    type="password"
                    class="form-control"
                    name="password"
                    required
                    v-model="form.password"
                  />

              </div>


                <div>
                  <v-btn type="submit" class="btn btn-primary">Register</v-btn>
                </div>

            </form>
          </v-card-text>
        </v-card>
      </v-col >
    </v-row>
  </v-container>
</template>


<script>
import firebase from "firebase";

export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        idcliente: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      var idc = this.form.idcliente;
      console.log("idcliente:",idc)
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.form.name,
              providerData:{idcliente: idc}
            })
            .then(() => {});
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>